import { z } from "zod";

export const ViewAttendanceFormSchema = z
  .object({
    startDate: z.date({ error: "Start date is required" }),
    endDate: z.date({ error: "End date is required" }),
    // placeholder for errors that span both dates. react-hook-form won't add errors to the formState if they're not in the schema.
    // zod v4 stopped inferring a bare z.undefined() field as omittable in the input type, hence .optional().
    dateRangeError: z.undefined().optional(),
  })
  .superRefine((dates, ctx) => {
    const { startDate, endDate } = dates;
    if (startDate > endDate) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["dateRangeError"], message: "End date cannot be before start date" });
    }

    if (Math.abs(startDate.getTime() - endDate.getTime()) > 1000 * 60 * 60 * 24 * 7) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["dateRangeError"], message: "Date range cannot be more than 7 days" });
    }
  });

export type ViewAttendanceFormType = z.infer<typeof ViewAttendanceFormSchema>;
